var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgSpinner = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.9
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.938 25.375a1.438 1.438 0 1 0 0-2.875 1.438 1.438 0 0 0 0 2.875Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15 7.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.679 22.071a1.25 1.25 0 1 0 0-2.5 1.25 1.25 0 0 0 0 2.5Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.946 10.179a2.375 2.375 0 1 0 0-4.75 2.375 2.375 0 0 0 0 4.75Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.875 14.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.563 16.625a2.062 2.062 0 1 0 0-4.125 2.062 2.062 0 0 0 0 4.125Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.491 9.125a.813.813 0 1 0 0-1.625.813.813 0 0 0 0 1.625Z",
  fill: "#242B36"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.321 23.073a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5Z",
  fill: "#242B36"
}))));

export default SvgSpinner;